module.exports = "<div class=\"thumbnail-box d-inline-flex align-items-center\" [ngbPopover]=\"popoverContent\" #popover=\"ngbPopover\"\r\n    placement=\"right\" triggers=\"hover\">\r\n    <img [src]=\"imageThumbnail\" class=\"thumbnail mx-auto\" />\r\n</div>\r\n<ng-template #popoverContent>\r\n    <div class=\"preview d-flex align-items-center\">\r\n        <img [src]=\"imagePreview\" class=\"mx-auto\" />\r\n    </div>\r\n</ng-template>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-image-preview-popover.component.html
// module id = 453
// module chunks = 11